// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root',
// })
export class Observer {
  private channel: RTCDataChannel | null;

  constructor(channel: RTCDataChannel | null) {
    this.channel = channel;
  }

  onNext(message: any) {
    if (!this.channel || this.channel.readyState !== 'open') {
      return;
    }
    this.channel.send(message.buffer);
  }
}
